export default "__VITE_ASSET__BnL19Roo__"